import { useEffect, useState } from "react";

import { ArrowButton } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getProfessionById } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { Profession } from "../../models/Profession";
import { codebookRouteProfession } from "../../routes/routes";
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookKnowledgeCheckDetails(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const [profession, setProfession] = useState<Profession>();

  useEffect(() => {
    if (!location || !location.state || !(location.state as any).professionId) {
      return
    }
    const getProfession = async () => {
      var result = await getProfessionById((location.state as any).professionId);
      setProfession(result);
    }
    getProfession();
  }, [location]);

  const navigateToList = () => {
    history.push(
      codebookRouteProfession(),
      {
        page: "list"
      }
    );
  }

  return (
    <>
      {profession &&
        <>
          <Row>
            <Col md={9}>
              <ArrowButton backwards ariaLabel="" onClick={navigateToList} />
              <span className={styles.backButtonCaption}>
                {t("codeBook.returnToList")}
              </span>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={8}>
              <h3>{t("codeBook.profession")}</h3>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={8} >
              <StaticField
                label={t("common.name")}
                value={profession.name}
              />
            </Col>
          </Row>
        </>
      }
    </>
  );
}